import pdf from '@/sui/tools/pdf'

export default {
  exportPDF: function (caracteristics, title, subtitle) {
    const styles = {
      h2: {
        fontSize: 12,
        margin: [0, 0, 0, 5],
        color: '#0b89c0'
      },

      h2sub: {
        fontSize: 8,
        margin: [0, 0, 0, 10],
        color: 'gray'
      },

      h3: {
        fontSize: 9,
        color: '#0b89c0'
      },

      std: {
        color: '#0b89c0'
      },

      columnHeader: {
        fontSize: 8
      },

      center: {
        alignment: 'center'
      },

      value: {
        alignment: 'right'
      },

      bold: {
        bold: true
      }
    }

    const content = [
      { text: title, style: 'h2' }
    ]

    if (subtitle !== '') {
      content.push({ text: subtitle, style: 'h2sub' })
    }

    const body = []

    const widths = ['*', 35, 35]

    caracteristics.forEach(
      c => {
        body.push(
          [
            {
              text: c.title,
              style: 'h3',
              colSpan: 2
            },
            {}
          ]
        )
        c.lines.forEach(
          d => {
            if (d.values.length === 0) {
              body.push([{ text: d.title, style: 'bold', colSpan: 2 }])
              return
            }

            const values = []
            d.values.forEach(
              v => {
                values.push(
                  [
                    v.label,
                    { text: `${v.count}`, style: ['bold', 'value'] },
                    v.percentage ? { text: v.percentage, style: 'value' } : ' '
                  ]
                )
              }
            )
            body.push(
              [
                d.title,
                {
                  layout: {
                    hLineWidth: (i, node) => 0,
                    vLineWidth: (i, node) => 0
                  },
                  table: {
                    widths: widths,
                    body: [
                      ...values
                    ]
                  }
                }
              ]
            )
          }
        )
      }
    )

    content.push(
      {
        fontSize: 7,
        layout: {
          hLineWidth: function (i, node) {
            return i < 1 ? 0 : 1
          },

          vLineWidth: function (i, node) {
            return 0
          },

          hLineColor: function (i, node) {
            return 'gray'
          },

          paddingLeft (i) {
            return i === 0 ? 0 : 1
          },

          paddingRight (i, node) {
            return (i < node.table.widths.length - 1) ? 1 : 0
          }
        },
        table: {
          dontBreakRows: true,
          widths: ['*', 'auto'],
          body: body
        }
      }
    )
    const definition = {
      pageStyle: 'A4',
      content: content,
      styles: styles,
      footer: (current, count) => {
        return {
          text: `${title} - page ${current}/${count}`,
          fontSize: 6,
          alignment: 'center'
        }
      }
    }
    const filename = `${title}.pdf`
    pdf.createPdf(definition).download(filename)
  }
}
